import capitalize from 'lodash/capitalize';

import {
  ActivityChangeOptions,
  ActivityItem,
  ActivityTagItem,
} from '@spotify/plugin-confidence-activity-react';
import { createWorkflowUpdatesChangeExtension } from '@spotify/plugin-confidence-workflows-react';

interface DecisionData {
  conclusion?: string;
  outcome?: string;
  treatment?: string;
}

const formatOutcome = (outcome: string | undefined): string => {
  if (!outcome) return '';
  return capitalize(outcome);
};

const DecisionChangeRender = ({ change }: ActivityChangeOptions) => {
  const oldValue = change.oldValue as DecisionData | null;
  const newValue = change.newValue as DecisionData | null;

  const outcomeChanged = oldValue?.outcome !== newValue?.outcome;
  const conclusionChanged = oldValue?.conclusion !== newValue?.conclusion;
  const treatmentChanged = oldValue?.treatment !== newValue?.treatment;

  return (
    <>
      {outcomeChanged && (
        <ActivityItem.Section label="Updated outcome">
          <ActivityTagItem
            oldValue={formatOutcome(oldValue?.outcome)}
            newValue={formatOutcome(newValue?.outcome)}
          />
        </ActivityItem.Section>
      )}
      {conclusionChanged && (
        <ActivityItem.Section label="Updated conclusion">
          <ActivityTagItem
            oldValue={oldValue?.conclusion}
            newValue={newValue?.conclusion}
          />
        </ActivityItem.Section>
      )}
      {treatmentChanged && (
        <ActivityItem.Section label="Updated shipped treatment">
          <ActivityTagItem
            oldValue={oldValue?.treatment}
            newValue={newValue?.treatment}
          />
        </ActivityItem.Section>
      )}
    </>
  );
};

// Export for testing
export const decisionChangePredicate = ({
  change,
}: {
  change: Pick<
    ActivityChangeOptions['change'],
    'fieldPath' | 'oldValue' | 'newValue'
  >;
}): boolean => {
  if (change.fieldPath !== '/module_data/decision') return false;
  const oldValue = change.oldValue as DecisionData | null;
  const newValue = change.newValue as DecisionData | null;
  return (
    oldValue?.outcome !== newValue?.outcome ||
    oldValue?.conclusion !== newValue?.conclusion ||
    oldValue?.treatment !== newValue?.treatment
  );
};

export const DECISION_CHANGE_EXTENSION = createWorkflowUpdatesChangeExtension({
  id: 'decision-change',
  predicate: decisionChangePredicate,
  title: () => 'Updated decision',
  render: DecisionChangeRender,
});
